// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"197":"09960eb0","212":"4af02abf","396":"c56cbdf0","421":"25b1d5ea","655":"d3e4275c","996":"a3ba4a6d"}[chunkId] + ".chunk.css";
};